import React from 'react'
import { useTranslation } from 'react-i18next'
import LabelWithTooltip from '../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../objectDetails/fields/common/PopoverContent'

export const AmenitiesLabel: React.FC = () => {
  const { t } = useTranslation()

  return (
    <LabelWithTooltip
      inputId='amenities'
      labelText={t('wizard.screen.otherFacilities.amenities', 'Ausstattung')}
      tooltipContent={<PopoverContent translationKey='wizard.screen.otherFacilities.amenitiesPopover.content' />}
      showMandatory={false}
      containerClassName='margin-bottom-s'
    />
  )
}
